export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const logo = require("../assets/logo.png");
export const checkMark = require("../assets/checkMark.png");
export const edit = require("../assets/edit.png")
export const LinkIcon = require("../assets/linkIcon.png")
export const upload = require("../assets/upload-3.png")
export const blackEditIconPng = require("../assets/blackEditPng.png");